import React from "react";
export default function MensajeError({mensaje}){
    return <div>{mensaje.data}</div>
}